var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputTag',{attrs:{"disabled":_vm.config.readOnly,"on-change":_vm.handleCustomValueChange,"tags":_vm.formattedValue,"data-test-id":_vm.config.key + 'Input'}})}
var staticRenderFns = []

export { render, staticRenderFns }